import { render, staticRenderFns } from "./SubmissionConfirmation.vue?vue&type=template&id=2ca8983c&scoped=true"
import script from "./SubmissionConfirmation.vue?vue&type=script&lang=js"
export * from "./SubmissionConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SubmissionConfirmation.vue?vue&type=style&index=0&id=2ca8983c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca8983c",
  null
  
)

export default component.exports